import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  InputSignal,
  input,
} from '@angular/core';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderComponent {
  readonly total: InputSignal<number> = input<number>(0);
  readonly title: InputSignal<string> = input<string>();

  @Output()
  filter: EventEmitter<any> = new EventEmitter();
}
